export default function supportSWPushNotification() {
    return Promise.resolve('serviceWorker' in navigator).then(browserSupportsServiceWorkers => {
        return (
            browserSupportsServiceWorkers &&
            navigator.serviceWorker
                .getRegistration()
                .then((registeredSW: ServiceWorkerRegistration) => {
                    return !!registeredSW && !!registeredSW.showNotification;
                })
        );
    });
}
